module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../../node_modules/happypack/loader.js?id=jsx!./activitiesOrderView.js"));
	}, "MyShareView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=MyShareView!./src/pages/Shop/Visitor/MyShare/activitiesOrder/activitiesOrderView.js
// module id = 1816
// module chunks = 367